import React, { useEffect, useState } from "react";
import Select from "react-select";
import * as api from "../constant/API";
import Utils from "../constant/Utils";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import { all_routes } from "../router/all_routes";
import { Button } from "react-bootstrap";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

const CoachPerformanceReport = () => {

    const routes = all_routes;
    const roleId = localStorage.getItem('RoleId');

    const [instituteList, setInstituteList] = useState([]);
    const [coachList, setCoachList] = useState([]);
    const [performanceList, setPerformanceList] = useState([]);
    const [loggedinList, setLoggedInList] = useState([]);
    const [activityList, setActivityList] = useState([]);
    const [instituteGrp, setInstituteGrp] = useState('All');
    const [institutionId, setInstitutionId] = useState('All');
    const [coachId, setCoachId] = useState('All');
    const [fromDate, setFromDate] = useState(() => new Date().toISOString().split('T')[0]);
    const [toDate, setToDate] = useState(() => new Date().toISOString().split('T')[0]);
    const [searchInput, setSearchInput] = useState('');

    useEffect(() => {
        getInstList();
        getCochPerformRpt();
    }, [])

    function getInstList() {
        const inslst = api.GetReportInstitutions + '/' + roleId + '/' + instituteGrp;
        // const inslst = api.GetReportInstitutions + "?institutionTypeId=" + instituteGrp + "&userId=1" + "&roleId=" + roleId;
        fetch(inslst, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((insResponse) => insResponse.json())
            .then((insResult) => {
                if (insResult.error == false) {
                    setInstituteList(insResult.data)
                }
                else {
                    Swal.fire(insResult.message)
                    if (insResult.code == 401) {
                        Utils.logoutUser();
                    }
                }
                setInstituteList(insResult.data)

            })
            .catch((error) => {
                console.log("Failed to fetch institution list", error)
            })
    }

    function getCochPerformRpt() {
        const formData = new FormData();
        formData.append("institutionType", instituteGrp);
        formData.append("institutionId", institutionId);
        formData.append("coachId", coachId);
        formData.append("fromDate", formatDate(fromDate));
        formData.append("toDate", formatDate(toDate));
        const getcochPerform = api.AllCoachPerformance;
        fetch(getcochPerform, {
            method: "POST",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
            body: formData
        })
            .then((perfmResponse) => perfmResponse.json())
            .then((perfmResult) => {
                if (perfmResult.error == true) {
                    if (perfmResult.code == 401) {
                        Utils.logoutUser();
                    }
                } else {
                    if (perfmResult.data != null) {
                        setPerformanceList(perfmResult.data)
                        setLoggedInList(perfmResult.data.coachLogin)
                        setActivityList(perfmResult.data.coachPerformance)
                    }
                    setPerformanceList(perfmResult.data)
                    setLoggedInList(perfmResult.data.coachLogin)
                    setActivityList(perfmResult.data.coachPerformance)
                }
            })
    }

    function getCochList(insid: string) {
        const cochLst = api.GetCoachList + '/' + roleId + '/' + insid;
        // const cochLst = api.GetCoachList + "?InstituteId=" + insid + "&role=" + roleId + "&userId=1";
        fetch(cochLst, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((cochResponse) => cochResponse.json())
            .then((cochResult) => {
                if (cochResult.error == true) {
                    if (cochResult.code == 401) {
                        Utils.logoutUser();
                    }
                } else {
                    if (cochResult.data != null) {
                        setCoachList(cochResult.data)
                    }
                    setCoachList(cochResult.data)
                }
            })
            .catch((error) => {
                console.log("Failed to fetch coach list", error)
            })
    }

    function exportnow() {
        const formData = new FormData();
        formData.append("institutionType", instituteGrp);
        formData.append("institutionId", institutionId);
        formData.append("coachId", coachId);
        formData.append("fromDate", formatDate(fromDate));
        formData.append("toDate", formatDate(toDate));
        const exprt = api.ExportCoachPerformanceReport;
        fetch(exprt, {
            method: "POST",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
            body: formData,
        })
            .then((exportReponse) => exportReponse.json())
            .then((exportResult) => {
                if (exportResult.error == true) {
                    if (exportResult.code == 401) {
                        Utils.logoutUser();
                    }
                } else {
                    const blob = new Blob([exportResult.data], { type: "application/vnd.ms-excel" });
                    const url = URL.createObjectURL(blob);
                    const a = document.createElement("a");
                    a.href = url;
                    a.download = "CoachPerformanceReport.xls"; // Save file as .xls
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                    URL.revokeObjectURL(url);
                }
            })
            .catch((error) => {
                console.log("Failed to export Coach Performance Report", error);
            })
    }

    const formatDate = (date) => {
        const dateObj = new Date(date);
        const day = String(dateObj.getDate()).padStart(2, '0');
        const month = String(dateObj.getMonth() + 1).padStart(2, '0');
        const year = dateObj.getFullYear();
        return `${day}-${month}-${year}`;
    };

    const filteredData = loggedinList.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value !== null && value !== undefined ? value.toString().toLowerCase() : '');
        return values.some((value) => value.includes(searchInput.toLowerCase()));
    });

    const filteredActivityData = activityList.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value !== null && value !== undefined ? value.toString().toLowerCase() : '');
        return values.some((value) => value.includes(searchInput.toLowerCase()));
    });

    const slNoRender = (rowData, column) => {
        return column.rowIndex + 1;
    };

    const coachRender = (rowData) => {
        return <span>{rowData.coachName}</span>
    }

    const dateRender = (rowData) => {
        return <span>{formatDate(rowData.coachActivityDate)}</span>
    }

    const slNoActRender = (rowData, column) => {
        return column.rowIndex + 1;
    };

    const instituteRender = (rowData) => {
        return <span>{rowData.institutionName}</span>
    }

    const coachActRender = (rowData) => {
        return <span>{rowData.coachName}</span>
    }

    const batchRender = (rowData) => {
        return <span>{rowData.batchName}</span>
    }

    const scheduleRender = (rowData) => {
        const formattedDate = rowData.coachhistoryScheduleDate.split(' ')[0];
        return <span>Schedule was created on {formatDate(formattedDate)}</span>
    }

    const sessionRender = (rowData) => {
        return <span>{rowData.coachhistorySessionDuration}</span>
    }

    const attendanceRender = (rowData) => {
        // const formattedDateTime = rowData.coachhistoryAttendanceDate.slice(0, 16); // Extracts "YYYY-MM-DD HH:MM"
        const dateTime = rowData.coachhistoryAttendanceDate;
        const [date, time] = dateTime.split(' '); // Split into date and time
        const [year, month, day] = date.split('-'); // Extract year, month, and day
        const formattedDateTime = `${day}-${month}-${year} ${time}`; // Format as DD-MM-YYYY HH:MM:SS
        return <span>Attendance was updated on {(formattedDateTime)}</span>
    }

    function getReport() {
        getCochPerformRpt();
    }

    return (
        <>
            <div className="content container">
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row d-flex align-items-center">
                                <h3 className="text-center mb-40">
                                    <i className="fa fa-university"></i>
                                    Coach Performance Report
                                </h3>
                            </div>
                            <div>
                                <Link
                                    to={routes.reports}
                                    className="btn btn-primary save-profile"
                                >
                                    <i className="fas fa-arrow-left"></i>Back
                                </Link>
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="court-tab-content">
                                        <div className="court-tab-content">
                                            <div className="card card-tableset">
                                                <div className="card-body">
                                                    <div className="coache-head-blk">
                                                        <div className="row align-items-center">
                                                            <div className="row col-md-12">
                                                                <div className="row col-md-12 court-sortby sortbyset">
                                                                    <div className="col-md-3">
                                                                        <div className="mb-10">
                                                                            <label className="sortbytitle"><h6>Institute</h6></label>
                                                                            <Select value={instituteList.find(inst => inst.institutionId === institutionId) ? {
                                                                                value: institutionId,
                                                                                label: instituteList.find(inst => inst.institutionId === institutionId).institutionName
                                                                            } : null}
                                                                                onChange={(e) => {
                                                                                    setInstitutionId(e.value)
                                                                                    getCochList(e.value)
                                                                                }}
                                                                                options={instituteList.map(inst => ({
                                                                                    value: inst.institutionId,
                                                                                    label: inst.institutionName
                                                                                }))}
                                                                                placeholder={"Select Institute"}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-2">
                                                                        <div className="mb-10">
                                                                            <label className="sortbytitle"><h6>Coach</h6></label>
                                                                            <Select value={coachList.find(coch => coch.icsCoach === coachId) ? {
                                                                                value: coachId,
                                                                                label: coachList.find(coch => coch.icsCoach === coachId).CoachName
                                                                            } : null}
                                                                                onChange={(e) => {
                                                                                    setCoachId(e.value)
                                                                                }}
                                                                                options={coachList.map(coch => ({
                                                                                    value: coch.icsCoach,
                                                                                    label: coch.CoachName
                                                                                }))}
                                                                                placeholder={"Select Coach"}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-2">
                                                                        <div className="mb-10">
                                                                            <label className="sortbytitle"><h6>From Date</h6></label>
                                                                            <input type="date" style={{ border: "1px solid hsl(0, 0%, 80%)", borderRadius: "4px", minHeight: "38px" }} value={fromDate} onChange={(e) => setFromDate(e.target.value)}></input>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-2">
                                                                        <div className="mb-10">
                                                                            <label className="sortbytitle"><h6>To Date</h6></label>
                                                                            <input type="date" style={{ border: "1px solid hsl(0, 0%, 80%)", borderRadius: "4px", minHeight: "38px" }} value={toDate} onChange={(e) => setToDate(e.target.value)}></input>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-3">
                                                                        <div className="save-changes text-sm mt-4">
                                                                            <Button onClick={getReport}>Submit</Button>
                                                                            <Button onClick={exportnow}>Export</Button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-12"></div>
                                                            <div className="col-md-12 mt-4 pt-4">
                                                                <div className="text-center">
                                                                    {formatDate(fromDate) === formatDate(toDate) ? (
                                                                        <h6>Details of Date: {formatDate(fromDate)}</h6>
                                                                    ) : (
                                                                        <h6>Details of: {formatDate(fromDate)} to {formatDate(toDate)}</h6>
                                                                    )}
                                                                </div>
                                                            </div>
                                                            <div className="row col-md-12">
                                                                <table className="table datatable">
                                                                    <thead className="thead-light">
                                                                        <tr>
                                                                            <th className="text-center text-uppercase">Number of coach logged in</th>
                                                                            <th className="text-center text-uppercase">Number of Schedules created</th>
                                                                            <th className="text-center text-uppercase">Number of attendance marked</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <tr>
                                                                            <td className="text-center">{performanceList.coachLoginCount}</td>
                                                                            <td className="text-center">{performanceList.coachScheduleCount}</td>
                                                                            <td className="text-center">{performanceList.coachAttendanceCount}</td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                            <div className="col-md-12 mt-4 pt-4">
                                                                <div className="text-center"><h6><i className="fas fa-user-check" />Coaches Logged In</h6></div>
                                                            </div>
                                                            <div className="col-md-12">
                                                            </div>
                                                            <div className="col-md-12">
                                                            </div>
                                                            <div className="col-md-6">
                                                            </div>
                                                            <div className="col-md-6">
                                                                <div className="dataTables_filter">
                                                                    <label>
                                                                        <input
                                                                            type="text"
                                                                            value={searchInput}
                                                                            onChange={(e) => setSearchInput(e.target.value)}
                                                                            placeholder="Search"
                                                                            className="form-control"
                                                                        />
                                                                    </label>
                                                                </div>
                                                            </div>
                                                            <div className="row col-md-12">
                                                                <div className="tab-content">
                                                                    <div
                                                                        className="tab-pane fade show active"
                                                                        id="nav-Recent"
                                                                        role="tabpanel"
                                                                        aria-labelledby="nav-Recent-tab"
                                                                        tabIndex={0}
                                                                    >
                                                                        <div className="table-responsive table-datatble">
                                                                            <DataTable
                                                                                className="table datatable"
                                                                                value={filteredData}
                                                                                paginator
                                                                                rows={10}
                                                                                rowsPerPageOptions={[10, 25, 50, 100]}
                                                                                // currentPageReportTemplate="{first}- {last} of {totalRecords} entries"
                                                                                pageLinkSize={3}
                                                                            >
                                                                                <Column
                                                                                    sortable
                                                                                    headerClassName="text-uppercase"
                                                                                    field="slNo"
                                                                                    body={slNoRender}
                                                                                    header="Sl No"
                                                                                ></Column>
                                                                                <Column
                                                                                    sortable
                                                                                    headerClassName="text-uppercase"
                                                                                    field="coachName"
                                                                                    body={coachRender}
                                                                                    header="Coach"
                                                                                ></Column>
                                                                                <Column
                                                                                    sortable
                                                                                    headerClassName="text-uppercase"
                                                                                    field="coachActivityDate"
                                                                                    body={dateRender}
                                                                                    header="Date"
                                                                                ></Column>
                                                                            </DataTable>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-12 mt-4 pt-4">
                                                                <div className="text-center"><h6><i className="fas fa-user-check" />Coaches Activity</h6></div>
                                                            </div>
                                                            <div className="col-md-12">
                                                            </div>
                                                            <div className="col-md-12">
                                                            </div>
                                                            <div className="col-md-6">
                                                            </div>
                                                            <div className="col-md-6">
                                                                <div className="dataTables_filter">
                                                                    <label>
                                                                        <input
                                                                            type="text"
                                                                            value={searchInput}
                                                                            onChange={(e) => setSearchInput(e.target.value)}
                                                                            placeholder="Search"
                                                                            className="form-control"
                                                                        />
                                                                    </label>
                                                                </div>
                                                            </div>
                                                            <div className="row col-md-12">
                                                                <div className="tab-content">
                                                                    <div
                                                                        className="tab-pane fade show active"
                                                                        id="nav-Recent"
                                                                        role="tabpanel"
                                                                        aria-labelledby="nav-Recent-tab"
                                                                        tabIndex={0}
                                                                    >
                                                                        <div className="table-responsive table-datatble">
                                                                            <DataTable
                                                                                className="table datatable"
                                                                                value={filteredActivityData}
                                                                                paginator
                                                                                rows={10}
                                                                                rowsPerPageOptions={[10, 25, 50, 100]}
                                                                                // currentPageReportTemplate="{first}- {last} of {totalRecords} entries"
                                                                                pageLinkSize={3}
                                                                            >
                                                                                <Column
                                                                                    sortable
                                                                                    headerClassName="text-uppercase"
                                                                                    field="slNo"
                                                                                    body={slNoActRender}
                                                                                    header="Sl No"
                                                                                ></Column>
                                                                                <Column
                                                                                    sortable
                                                                                    headerClassName="text-uppercase"
                                                                                    field="institutionName"
                                                                                    body={instituteRender}
                                                                                    header="Institute"
                                                                                ></Column>
                                                                                <Column
                                                                                    sortable
                                                                                    headerClassName="text-uppercase"
                                                                                    field="coachName"
                                                                                    body={coachActRender}
                                                                                    header="Coach"
                                                                                ></Column>
                                                                                <Column
                                                                                    sortable
                                                                                    headerClassName="text-uppercase"
                                                                                    field="batchName"
                                                                                    body={batchRender}
                                                                                    header="Batch Information"
                                                                                ></Column>
                                                                                <Column
                                                                                    sortable
                                                                                    headerClassName="text-uppercase"
                                                                                    field="coachhistoryScheduleDate"
                                                                                    body={scheduleRender}
                                                                                    header="Schedule Information"
                                                                                ></Column>
                                                                                <Column
                                                                                    sortable
                                                                                    headerClassName="text-uppercase"
                                                                                    field="coachhistorySessionDuration"
                                                                                    body={sessionRender}
                                                                                    header="Session Information"
                                                                                ></Column>
                                                                                <Column
                                                                                    sortable
                                                                                    headerClassName="text-uppercase"
                                                                                    field="coachhistoryAttendanceDate"
                                                                                    body={attendanceRender}
                                                                                    header="Attendance Information"
                                                                                ></Column>
                                                                            </DataTable>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div >
                    </div >
                </div >
            </div >
        </>
    );
};

export default CoachPerformanceReport;